import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { InsuranceAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { getFilters, viewTypeList } from "./insuranceDto";
import { useTranslation } from "react-i18next";
export var InsuranceView = function (props) {
    var t = useTranslation().t;
    return (_jsx(InsuranceAFY, { title: props.insurance.titlePage, titlePagination: t("recordsPerPage"), countPagination: props.countPagination, pagePagination: props.insurancePage, rowsPerPage: props.insuranceLimit, rowsPerPageOption: [10, 20, 25, 50], data: props.insurance.data, filters: getFilters(props.insuranceFilters), viewTypeList: viewTypeList, onClick: function (item) { return props.clickCard && props.clickCard(item); }, onChangeFilterTerm: props.searchFilter, onClickButtonView: function (option) {
            props.clickView && props.clickView(option);
        }, onChangeFilter: function (data) {
            props.onChangeFilters(data);
        } }));
};
